// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2_FqP","Next":"Button_Next__2iKSO"};